<script setup lang="ts">
import { onMounted, onUnmounted, ref, useTemplateRef } from 'vue'
import { string } from 'yup'
import { stringErr } from '@/constants'
import { postConselingRequest } from '~/api/conseling-request'
import { toEnglishDigits } from '~/utils/to-english-number.util'

const phoneInputRef = useTemplateRef('phoneInput')

const visible = ref(false)
// const scrollCount = ref(0);

const validationSchema = {
  fullName: string().required(stringErr),
}

const initialValues = {
  fullName: '',
}

const isSubmitting = ref(false)
const hasShownDialog = ref(false)

const onSubmit = async (values: { fullName: string }) => {
  const phoneComp = phoneInputRef.value
  if (!phoneComp || typeof phoneComp.inputPhoneValidate !== 'function') {
    console.warn('phone input ref not found or validatePhone not available')
    return
  }

  const result = await phoneComp.inputPhoneValidate()
  if (!result || !result.isValid) {
    return
  }

  const formData = {
    fullName: values.fullName,
    phone: toEnglishDigits(result.phone),
  }
  isSubmitting.value = true
  await postConselingRequest(formData.fullName, formData.phone)
  isSubmitting.value = false
  visible.value = false
  values = initialValues
}

const SESSION_KEY = 'consultation-modal-shown'

const onScroll = () => {
  const scrolledPixels = window.scrollY

  // Trigger after scrolling 2 screen heights
  const threshold = window.innerHeight * 1.5

  if (scrolledPixels >= threshold && !hasShownDialog.value && !sessionStorage.getItem(SESSION_KEY)) {
    visible.value = true
    hasShownDialog.value = true
    sessionStorage.setItem(SESSION_KEY, 'true')
  }
}

onMounted(() => {
  window.addEventListener('scroll', onScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll)
})
</script>

<template>
  <Dialog
    v-model:visible="visible"
    class="!bg-[#2626BF] text-[#0f1114] consultation-modal pt-4 pb-2 px-2 rounded-none lg:rounded-3xl"
    modal
    :closable="false"
    dir="rtl"
    :dismissable-mask="true"
    :close-on-escape="true"
    :style="{ width: '740px' }"
  >
    <div class="flex flex-col-reverse lg:flex-row justify-between">
      <div class="flex flex-col lg:flex-row items-center gap-2">
        <img
          class="lg:-ms-2"
          src="/home/img/home/headphone2.svg"
          alt=""
          aria-hidden="true"
        />

        <h2 class="text-3xl lg:text-[40px] font-bold text-[#FFBF00]">
          فرم درخواست مشاوره
        </h2>
      </div>
      <button
        type="button"
        class="flex justify-end w-full lg:w-fit cursor-pointer"
        @click="visible = false"
        aria-label="بستن فرم درخواست مشاوره"
        tabindex="0"
        role="button"
      >
        <img src="/home/img/home/icon-close.svg" alt="" />
      </button>
    </div>
    <div
      class="w-full rounded-xl bg-white flex flex-col p-6 gap-4 mt-10 lg:mt-6"
    >
      <p class="text-[#0F1114]">
        برای دریافت مشاوره رایگان نام و شماره تماس خود را وارد کنید.
      </p>
      <UiForm
        :validation-schema="validationSchema"
        :initial-values="initialValues"
        @submit="onSubmit"
      >
        <div class="flex flex-col lg:flex-row items-center gap-4">
          <div
            class="w-full lg:w-fit flex-grow flex flex-col lg:flex-row items-center gap-4 text-[#0F1114]"
          >
            <UiInputText name="fullName" placeholder="نام و نام خانوادگی" />
            <LazyUiInputPhone
              ref="phoneInput"
              placeholder="شماره واتساپ یا تلگرام"
            />
          </div>
          <UiButton
            id="consultation-form-btn1"
            class="w-full lg:w-[151px] h-[48px]"
            :loading="isSubmitting"
          >
            ارسال
          </UiButton>
        </div>
      </UiForm>
    </div>
  </Dialog>
</template>
<style>
.consultation-modal .p-dialog-header {
  padding: 0 !important;
}
</style>
